import { render, staticRenderFns } from "./ChatsMobile.vue?vue&type=template&id=2ae72eea&scoped=true&"
import script from "./ChatsMobile.vue?vue&type=script&lang=js&"
export * from "./ChatsMobile.vue?vue&type=script&lang=js&"
import style0 from "./ChatsMobile.vue?vue&type=style&index=0&id=2ae72eea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae72eea",
  null
  
)

export default component.exports